<ion-card *mobxAutorun class="ion-no-margin ly-col flex md-border">
  <ion-row
    class="ion-margin-horizontal ion-margin-top ion-align-items-center ion-justify-content-between"
  >
    <ion-text color="medium">
      <b>{{ 'components.netsocialInsights.title' | translate }}</b>
    </ion-text>
    <ion-button
      size="small"
      fill="clear"
      class="ion-no-margin"
      href="https://www.netsocialapp.com/blog/"
      target="_blank"
    >
      {{ 'components.netsocialInsights.buttons.launchSite' | translate }}
      <ion-icon name="open-outline" slot="end"></ion-icon>
    </ion-button>
  </ion-row>
  <ion-list class="flex" *ngIf="!loading">
    <div *ngFor="let item of items" lines="inset">
      <ion-item >
        <a
        [href]="item.link[i]"
        target="_blank"
        *ngFor="let title of item.title; let i = index"
      >
        <h6>{{ title }}</h6>
      </a>
    </ion-item>
    <ion-item>
      <ion-img [src]="item.previewImage"></ion-img>
    </ion-item>
    </div>
    <empty-state
      class="ion-padding"
      *ngIf="!items?.length"
      [showAction]="false"
      title="components.netsocialInsights.messages.emptyTitle"
      description=""
    >
    </empty-state>
  </ion-list>
  <ion-list *ngIf="loading">
    <ion-item>
      <ng-container>
        <ion-skeleton-text animated></ion-skeleton-text>
      </ng-container>
    </ion-item>
    <ion-item>
      <ng-container>
        <ion-skeleton-text animated></ion-skeleton-text>
      </ng-container>
    </ion-item>
    <ion-item>
      <ng-container>
        <ion-skeleton-text animated></ion-skeleton-text>
      </ng-container>
    </ion-item>
  </ion-list>
  <!-- <ion-row class="stretch-x">
    <ion-button class="ion-no-margin stretch-x" expand="full">
      <ion-icon name="open-outline" slot="start"> </ion-icon>
      {{ 'components.netsocialInsights.buttons.moreInsights' | translate }}
    </ion-button>
  </ion-row> -->
</ion-card>
